/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ProspectEmailState {
  draft = 'draft',
  queued = 'queued',
  sending = 'sending',
  sent = 'sent',
  failed = 'failed'
}
